import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_10: FaireProductEntity = {
  token: "legacy_prod_abbott-10",
  type: "product",
  name: "Grey LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/860ebbe8ef7df6b57c0b22086161b721d13415f347efd4210830b64fd0640acc.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
